/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<5a45fc107d30040df3469556f4a9134e>>
 * @relayHash 4dce4c99748b4341c243d1e82ee812e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 388a195aea3dc4d39ac7c99e6e77fe2e7922755100aa077a15b444b663f9d295

import type { ConcreteRequest, Query } from 'relay-runtime';
export type helpCenterBrandingQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type helpCenterBrandingQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly announcements: {
        readonly canEditAnnouncement: boolean | null | undefined;
        readonly homePageAnnouncements: ReadonlyArray<{
          readonly description: string | null | undefined;
          readonly descriptionTranslationsRaw: ReadonlyArray<{
            readonly locale: string;
            readonly localeDisplayName: string;
            readonly value: string;
          }> | null | undefined;
          readonly name: string | null | undefined;
          readonly nameTranslationsRaw: ReadonlyArray<{
            readonly locale: string;
            readonly localeDisplayName: string;
            readonly value: string;
          }> | null | undefined;
        }> | null | undefined;
      } | null | undefined;
      readonly helpCenterBranding: {
        readonly banner: {
          readonly fileId: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined;
        readonly colors: {
          readonly bannerTextColor: string | null | undefined;
          readonly primary: string | null | undefined;
        } | null | undefined;
        readonly homePageTitle: {
          readonly default: string;
          readonly translations: ReadonlyArray<{
            readonly locale: string;
            readonly localeDisplayName: string;
            readonly value: string;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly isBannerAvailable: boolean | null | undefined;
        readonly isLogoAvailable: boolean | null | undefined;
        readonly logo: {
          readonly fileId: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined;
      };
      readonly name: {
        readonly default: string;
        readonly translations: ReadonlyArray<{
          readonly locale: string;
          readonly localeDisplayName: string;
          readonly value: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly siteDefaultLanguageTag: string | null | undefined;
      readonly userLanguageTag: string | null | undefined;
    } | {
      readonly __typename: "QueryError";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type helpCenterBrandingQuery = {
  response: helpCenterBrandingQuery$data;
  variables: helpCenterBrandingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "locale",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "localeDisplayName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "default",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "HelpCenterTranslation",
    "kind": "LinkedField",
    "name": "translations",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpCenterName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpCenterBranding",
  "kind": "LinkedField",
  "name": "helpCenterBranding",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterHomePageTitle",
      "kind": "LinkedField",
      "name": "homePageTitle",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterLogo",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterBanner",
      "kind": "LinkedField",
      "name": "banner",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterBrandingColors",
      "kind": "LinkedField",
      "name": "colors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerTextColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBannerAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLogoAvailable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpCenterAnnouncements",
  "kind": "LinkedField",
  "name": "announcements",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEditAnnouncement",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterAnnouncement",
      "kind": "LinkedField",
      "name": "homePageAnnouncements",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpCenterTranslation",
          "kind": "LinkedField",
          "name": "nameTranslationsRaw",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpCenterTranslation",
          "kind": "LinkedField",
          "name": "descriptionTranslationsRaw",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteDefaultLanguageTag",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userLanguageTag",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "helpCenterBrandingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v8/*: any*/),
                    "action": "THROW",
                    "path": "helpCenter.helpCenterById.helpCenterBranding"
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "HelpCenter",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "QueryError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "helpCenterBrandingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "HelpCenter",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4dce4c99748b4341c243d1e82ee812e8",
    "id": "388a195aea3dc4d39ac7c99e6e77fe2e7922755100aa077a15b444b663f9d295",
    "metadata": {},
    "name": "helpCenterBrandingQuery",
    "operationKind": "query",
    "text": "query helpCenterBrandingQuery(\n  $cloudId: ID!\n  $helpCenterAri: ID!\n) {\n  helpCenter(cloudId: $cloudId) {\n    helpCenterById(helpCenterAri: $helpCenterAri) @optIn(to: [\"HelpCenterAggBeta\"]) {\n      __typename\n      ... on HelpCenter {\n        __typename\n        name {\n          default\n          translations {\n            locale\n            localeDisplayName\n            value\n          }\n        }\n        helpCenterBranding @optIn(to: [\"HelpCenterBrandingTest\"]) {\n          homePageTitle {\n            default\n            translations {\n              locale\n              localeDisplayName\n              value\n            }\n          }\n          logo {\n            fileId\n            url\n          }\n          banner {\n            fileId\n            url\n          }\n          colors {\n            primary\n            bannerTextColor\n          }\n          isBannerAvailable\n          isLogoAvailable\n        }\n        announcements {\n          canEditAnnouncement\n          homePageAnnouncements {\n            name\n            description\n            nameTranslationsRaw {\n              locale\n              localeDisplayName\n              value\n            }\n            descriptionTranslationsRaw {\n              locale\n              localeDisplayName\n              value\n            }\n          }\n        }\n        siteDefaultLanguageTag\n        userLanguageTag\n      }\n      ... on QueryError {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acf9c8e0e7994bc318bae23627ed0d1a";

export default node;
